export default [
  {
    path: "/feeConfigurations",
    component: () => import(/* webpackChunkName: "cashouts" */ "./layout"),

    children: [
      {
        path: "/feeConfigurations/instantTransfers",
        name: "instantTransfers.index",
        component: () => import(/* webpackChunkName: "instantTransfers" */ "./index"),
      },
      {
        path: "/feeConfigurations/:id/instantTransfers/offers",
        name: "instantTransfers.offers.index",
        component: () => import(/* webpackChunkName: "cashouts" */ "./offers/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/instantTransferOffers/:id",
        props: true,
        name: "instantTransfers.offers.show",
        component: () => import(/* webpackChunkName: "deposits.payinmethods" */ "./offers/show"),
      },
      {
        path: "/feeConfigurations/:id/instantTransfers/payinmethods",
        name: "instantTransfers.payinmethods.index",
        component: () =>
          import(/* webpackChunkName: "instantTransfers.payinmethods" */ "./payinMethods/index"),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/payInMethods/:id",
        props: true,
        name: "instantTransfers.payinmethods.show",
        component: () =>
          import(/* webpackChunkName: "instantTransfers.payinmethods" */ "./payinMethods/show"),
      },

      {
        path: "/feeConfigurations/:id/instantTransfers/countries",
        name: "instantTransfers.countries.index",
        component: () =>
          import(/* webpackChunkName: "instantTransfers.countries" */ "./countries/index"),
      },
      {
        path: "/feeConfigurations/:id/instantTransfers/countrymappings",
        name: "instantTransfers.countrymappings.index",
        component: () =>
          import(
            /* webpackChunkName: "instantTransfers.countrymappings" */ "./countryMappings/index"
          ),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/countriesMappings/:id",
        props: true,
        name: "instantTransfers.countriesMappings.show",
        component: () =>
          import(
            /* webpackChunkName: "instantTransfers.countriesMappings.show" */ "./countryMappings/show"
          ),
      },
      {
        path: "/feeConfigurations/:feeConfigurationId/countries/:id",
        props: true,
        name: "instantTransfers.countries.show",
        component: () =>
          import(/* webpackChunkName: "instantTransfers.countries" */ "./countries/show"),
      },
    ],
  },
];
